import React from 'react';
import { Box, Stack, Typography } from '@mui/material';

const InfoItem = ({ icon, label, value, color = 'primary' }) => (
    <Box
        sx={{
            p: 1.5,
            bgcolor: 'background.paper',
            borderRadius: 2,
            border: '1px solid',
            borderColor: 'divider',
            height: '100%',
        }}
    >
        <Stack spacing={0.5}>
            <Stack direction="row" spacing={1} alignItems="center">
                {React.cloneElement(icon, {
                    fontSize: 'small',
                    color: color,
                })}
                <Typography
                    variant="caption"
                    color="text.secondary"
                    fontWeight={600}
                    noWrap
                >
                    {label}
                </Typography>
            </Stack>
            <Typography
                variant="body2"
                fontWeight={500}
                sx={{ wordBreak: 'break-word' }}
            >
                {value}
            </Typography>
        </Stack>
    </Box>
);

export default InfoItem;
